<template>
  <!-- Row and card styles are the page's shared grouped list (index.vue). -->
  <section v-if="visits.length" class="scan-today" aria-labelledby="scan-today-title">
    <h2 id="scan-today-title" class="attendee-scan__group-title">
      Today
      <span v-if="label" class="attendee-scan__group-date">{{ label }}</span>
    </h2>

    <div class="attendee-scan__group">
      <ul class="scan-today__list">
        <li v-for="(visit, index) in visits" :key="`${visit.session_id}-${visit.in}-${index}`" class="attendee-scan__row">
          <span class="attendee-scan__row-icon attendee-scan__row-icon--done" aria-hidden="true">
            <i class="fa-solid fa-check"></i>
          </span>
          <div class="attendee-scan__row-text">
            <b class="attendee-scan__row-title">{{ visit.session_name }}</b>
            <!-- The count tells the range is not one unbroken stay: only time
                 inside the room is added up. -->
            <div class="attendee-scan__row-meta">
              {{ visit.in }} – {{ visit.out }}<template v-if="visit.visits_count > 1"> · {{ visit.visits_count }} visits</template>
            </div>
          </div>
          <span class="attendee-scan__row-value">{{ span(visit.duration_seconds) }}</span>
        </li>
      </ul>

      <div class="attendee-scan__group-sum">
        <span>
          Time in sessions today
          <!-- Without this the total looks short next to a running timer. -->
          <small v-if="hasLive">Your current session is added when you scan out</small>
        </span>
        <strong>{{ span(totalSeconds) }}</strong>
      </div>
    </div>
  </section>
</template>

<script>
import { formatSpan } from './scan-clock';

export default {
  props: {
    // Rows of GET scan/today.
    visits: { type: Array, default: () => [] },
    // The day the rows cover, in the event's timezone ("Thu, Oct 22").
    label: { type: String, default: '' },
    // An open visit is not in the list yet, so the total leaves it out.
    hasLive: { type: Boolean, default: false },
  },
  computed: {
    totalSeconds() {
      return this.visits.reduce((sum, visit) => sum + (visit.duration_seconds || 0), 0);
    },
  },
  methods: {
    span(seconds) {
      return formatSpan(seconds * 1000);
    },
  },
}
</script>

<style lang="scss" scoped>
.scan-today__list {
  margin: 0;
  padding: 0;
  list-style: none;
}
</style>
